import {html} from '@isceco/widget-library2/external/lit'
import '@isceco/widget-library2/basic-elements/Title/Title'
import '@isceco/widget-library2/basic-elements/List/StaticList'
import WebComponent from '../../WebComponent.js'
import AdministrationColumns from './AdministrationColumns'
import FormConfigService from "../../services/FormConfigService"
import FormConfigDto from './FormConfigDto'

export default class Administration extends WebComponent {

  constructor() {
    super()
    this.service = new FormConfigService()
  }

  get translationFile() {
    return './views/Administration/i18n.json'
  }

  connectedCallback() {
    super.connectedCallback()
    this.reload()
  }

  reload() {
    Promise.resolve(
      this.service.getBackendListUrl()
    )
      .then(url => {
        this.url = url
      })
      .catch(_ => {
        this.url = ''
      })
      .finally(_ => {
        this.render()
      })
  }

  getTemplate() {
    return html`
      <isceco-title id="page-title" text="${this.i18n.translate('page.title')}"></isceco-title>

      <isceco-card text="${this.i18n.translate('administration.list')}">
        <isceco-filter-group>
          <isceco-string-filter label="${this.i18n.translate('administration.search')}"
                                minchars="0"
                                key="formKey">
          </isceco-string-filter>
        </isceco-filter-group>
        <isceco-list url="${this.url}"
                     .i18n="${this.i18n}"
                     .dtoMapper="${this._toDTO}"
                     .columns="${AdministrationColumns.getColumns()}"
                     .rowurl="${row => constructURL({to: 'AdministrationEdit', id: row.formKey})}"
                     sort="formKey"
                     order="asc"
        ></isceco-list>
      </isceco-card>
    `
  }

  _toDTO = row => new FormConfigDto(row)

}

customElements.define('eform-frontend-administration', Administration)
